export const FEATURES_LIST = [{
  title: '10分钟集成',
  desc: '快速拥有完整活动运营系统',
  img: 'operating-activities/10分钟集成.jpg'
}, {
  title: '奖品自动发放',
  desc: '丰富的电子化奖品库全自动发放',
  img: 'operating-activities/奖品自动发放.jpg'
}, {
  title: '丰富活动模板',
  desc: '海量模版实时更新',
  img: 'operating-activities/丰富活动模板.jpg'
}, {
  title: '本地化部署',
  desc: '从源头锁住敏感数据，满足数据安全需求',
  img: 'operating-activities/本地化部署.jpg'
}];
export const SKILL_LIST = [{
  img: 'ActivityCreation.png',
  title: '活动创建',
  desc: '抢红包、猜涨跌、签到、砸金蛋等十余款主流活动轻松搭建'
}, {
  img: 'DirectedDistribution.png',
  title: '定向分发',
  desc: '支持条件管理及活动分区功能，使得活动运营达到“千人千面”的效果'
}, {
  img: 'PrecisionMarketing.png',
  title: '精准营销',
  desc: '针对不同用户搭建不同的营销互动场景，实现精准营销'
}, {
  img: 'ActivityMonitoring.png',
  title: '活动监测',
  desc: '实时显示活动数据，方便运营人员对活动进行动态调优'
}, {
  img: 'ComponentManagement.png',
  title: '组件管理',
  desc: '轮播图片、跑马灯、倒计时等数十个组件赋能，支持第三方组件开发上传'
}, {
  img: 'Playbook.png',
  title: '玩法大全',
  desc: '支持奖品发放、复活机制、分享裂变等玩法，提升活动整体转化效果'
}, {
  img: 'Automaticawarding.png',
  title: '自动发奖',
  desc: '支持虚拟礼品、电子卡券、实物、话费等类型奖品的自动发放，后台实时显示奖品库存及发放报表'
}, {
  img: 'marketingStrategy.png',
  title: '营销策略',
  desc: '提供丰富的逻辑判断、流程控制、触达执行模块，用来实现客户营销旅程的设计和执行'
}];